module.exports = __webpack_public_path__ + "static/media/10B.8a575846.png";